import type { ProjectContext } from '@atlassian/jira-issue-shared-types/src/common/types/project-type.tsx';
import type { ProjectKey } from '@atlassian/jira-shared-types/src/general.tsx';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { StoreActionApi } from '@atlassian/react-sweet-state';
import type { State } from './types.tsx';

export const setProjectContext =
	(key: ProjectKey, projectContext: ProjectContext) =>
	({ setState }: StoreActionApi<State>): void => {
		// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
		setState({ [key as string]: projectContext });
	};

export const mergeProjectProperty =
	(key: ProjectKey, projectContext: Partial<ProjectContext>) =>
	({ setState, getState }: StoreActionApi<State>): void => {
		const currentState = getState();
		const currentProjectContext = currentState[key];
		const newProjectContext = { ...currentProjectContext, ...projectContext };
		// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
		setState({ [key as string]: newProjectContext });
	};
